<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21 23C21 20.7909 19.2091 19 17 19H15C12.7909 19 11 20.7909 11 23V25H9L9 23C9 19.6863 11.6863 17 15 17H17C20.3137 17 23 19.6863 23 23V25H21V23Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13ZM16 15C18.2091 15 20 13.2091 20 11C20 8.79086 18.2091 7 16 7C13.7909 7 12 8.79086 12 11C12 13.2091 13.7909 15 16 15Z"
        />
    </svg>
</template>
